var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurnBackgroundRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 165,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-4.2%",
    y: "-4.2%",
    width: "108.4%",
    height: "116.2%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.239 34.847 87.279 3.25a20 20 0 0 1 15.454-.029l75.96 31.65A20 20 0 0 1 191 53.333V130c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20V53.28a20 20 0 0 1 12.239-18.433Z",
    id: "b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fontFamily: "SpaceGrotesk-Bold, Space Grotesk",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    fontSize: 16,
    transform: "translate(51 41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.64,
    y: 16
  }, "YOUR TURN")), /*#__PURE__*/React.createElement("text", {
    fontSize: 56,
    transform: "translate(51 41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.872,
    y: 77
  }, "15s"))), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 3,
    d: "M86.697 1.868a21.5 21.5 0 0 1 16.613-.03l75.96 31.65a21.478 21.478 0 0 1 9.62 7.92 21.478 21.478 0 0 1 3.61 11.925V130a21.433 21.433 0 0 1-6.297 15.203A21.433 21.433 0 0 1 171 151.5H20a21.433 21.433 0 0 1-15.203-6.297A21.433 21.433 0 0 1-1.5 130V53.28c0-4.326 1.296-8.44 3.589-11.893a21.478 21.478 0 0 1 9.568-7.923Z",
    fill: "#FD6687"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnBackgroundRed);
export default __webpack_public_path__ + "static/media/turn-background-red.a17013f69456193c4ebcdcad8719a2e4.svg";
export { ForwardRef as ReactComponent };